<div *ngIf="viewActive">
  <div class="d-flex flex-row">
    <div class="d-flex justify-content-around text-center pb-1 w-100">
      <div class="btn-group">
        <div
          class="btn btn-primary"
          mwlCalendarPreviousView
          [view]="viewMode"
          [(viewDate)]="viewDate"
          (viewDateChange)="viewDateChanged($event)"
        >
          Previous
        </div>
        <div
          class="btn btn-outline-secondary"
          mwlCalendarToday
          [(viewDate)]="viewDate"
          (viewDateChange)="viewDateChanged($event)"
        >
          Today
        </div>
        <div
          class="btn btn-primary"
          mwlCalendarNextView
          [view]="viewMode"
          [(viewDate)]="viewDate"
          (viewDateChange)="viewDateChanged($event)"
        >
          Next
        </div>
      </div>
      <div class="h3 mb-0 d-flex flex-wrap">
        <div
          class="text-primary"
          role="button"
          (click)="beginEditDateMode()"
          *ngIf="!bEditDateMode"
        >
          {{ viewDate | calendarDate: viewMode + "ViewTitle":"en" }}
        </div>
        <div class="d-flex flex-row" *ngIf="bEditDateMode">
          <input
            type="date"
            name="viewDateFormVal"
            class="form-control"
            [(ngModel)]="viewDateFormVal"
            #calendarDateInput="ngModel"
            [ngClass]="{
              'invalid-input':
                calendarDateInput.invalid &&
                (calendarDateInput.dirty || calendarDateInput.touched)
            }"
          />
          <button
            class="mx-1 btn btn-primary"
            (click)="acceptFormDate()"
            [disabled]="calendarDateInput.invalid || calendarDateInput.pristine"
          >
            OK
          </button>
          <button class="btn btn-warning" (click)="rejectFormDate()">
            Cancel
          </button>
        </div>

        <div class="ml-2 font-italic text-secondary">({{ column.title }})</div>
      </div>
      <div class="btn-group">
        <div
          class="btn btn-primary"
          (click)="setViewMode(CalendarView.Month)"
          [class.active]="viewMode === CalendarView.Month"
        >
          Month
        </div>
        <div
          class="btn btn-primary"
          (click)="setViewMode(CalendarView.Week)"
          [class.active]="viewMode === CalendarView.Week"
        >
          Week
        </div>
        <div
          class="btn btn-primary"
          (click)="setViewMode(CalendarView.Day)"
          [class.active]="viewMode === CalendarView.Day"
        >
          Day
        </div>
      </div>
    </div>
    <div class="d-inline-block text-nowrap">
     <i role="button"
        class="p-1 mr-1 fa fa-window-minimize"
        (click)="closeCalendar.emit({clearFilter:false})"
        title="Keep date filter / hide calendar">
      </i>
      <i role="button"
        class="p-1 fa fa-window-close"
        (click)="closeCalendar.emit({clearFilter:true})"
        title="Clear date filter / hide calendar">
      </i>
    </div>
  </div>
  <div [ngSwitch]="viewMode">
    <mwl-calendar-month-view
      *ngSwitchCase="CalendarView.Month"
      [viewDate]="viewDate"
      [events]="events"
      (eventClicked)="onCalendarEventSelected($event.event)"
      (dayClicked)="onCalendarDaySelected($event.day)"
      [cellTemplate]="dayOfMonthTemplate"
    >
    </mwl-calendar-month-view>

    <ng-template
      #dayOfMonthTemplate
      let-day="day"
      let-locale="locale"
      let-openDay="openDay"
      let-tooltipPlacement="tooltipPlacement"
      let-highlightDay="highlightDay"
      let-unhighlightDay="unhighlightDay"
      let-eventClicked="eventClicked"
      let-tooltipTemplate="tooltipTemplate"
      let-tooltipAppendToBody="tooltipAppendToBody"
      let-tooltipDelay="tooltipDelay"
      let-trackByEventId="trackByEventId"
      let-validateDrag="validateDrag"
    >
      <div
        class="cal-cell-top"
        [attr.aria-label]="
          { day: day, locale: locale } | calendarA11y: 'monthCell'
        "
        *ngLet="groupedByDay[day.date | date: 'YYYY-MM-dd'] as dayTotal"
      >
        <div aria-hidden="true">
          <span
            class="cal-day-badge"
            [ngStyle]="{
              'background-color': day.badgeTotal ? 'green' : 'gray'
            }"
            *ngIf="dayTotal"
          >
            <ng-container
              *ngIf="day.badgeTotal > 0 && day.badgeTotal != dayTotal"
            >
              {{ day.badgeTotal }} of
            </ng-container>
            {{ groupedByDay[day.date | date: "YYYY-MM-dd"] }}
          </span>
          <span class="cal-day-number">{{
            day.date | calendarDate: "monthViewDayNumber":locale
          }}</span>
        </div>
      </div>
      <!--div class="cal-events" *ngIf="day.events.length > 0">
        <div
          *ngFor="let event of day.events; trackBy: trackByEventId"
          [ngStyle]="{ backgroundColor: event.color?.primary }"
          [ngClass]="event?.cssClass"
          (mouseenter)="highlightDay.emit({ event: event })"
          (mouseleave)="unhighlightDay.emit({ event: event })"
          [mwlCalendarTooltip]="
            event.title | calendarEventTitle: 'monthTooltip':event
          "
          [tooltipPlacement]="tooltipPlacement"
          [tooltipEvent]="event"
          [tooltipTemplate]="tooltipTemplate"
          [tooltipAppendToBody]="tooltipAppendToBody"
          [tooltipDelay]="tooltipDelay"
          mwlDraggable
          [class.cal-draggable]="event.draggable"
          dragActiveClass="cal-drag-active"
          [dropData]="{ event: event, draggedFrom: day }"
          [dragAxis]="{ x: event.draggable, y: event.draggable }"
          [validateDrag]="validateDrag"
          [touchStartLongPress]="{ delay: 300, delta: 30 }"
          (mwlClick)="eventClicked.emit({ event: event, sourceEvent: $event })"
          [attr.aria-hidden]="{} | calendarA11y: 'hideMonthCellEvents'"
          class="p-1"
        >
        </div>
      </div-->
    </ng-template>
  </div>
</div>
